export default {
  name: "mTab",
  props: {
    tab: {
      type: Array,
      default: () => []
    },
    selectTab: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      currentTab: null // 本地响应式副本
    };
  },

  watch: {
    tab: {
      handler(newList, oldList) {
        if (newList.length > 0 && (!this.selectTab || Object.keys(this.selectTab).length === 0)) {
          this.$emit("update:selectTab", newList[0]);
        }
      },
      deep: true,
      immediate: true
    },
    selectTab: {
      handler(newVal) {
        this.currentTab = newVal;
        console.log("this.currentTab", this.currentTab);
      },
      immediate: true
    }
  },
  methods: {
    onTab(item) {
      this.$emit("update:selectTab", item);
      this.$emit("tabFn", item);
    }
  }
};